import { CoachProfile, UserRole } from "@joonapp/web-shared"

import { MeTabCard, SubscriptionPackagesResponse } from "../../types"
import { CancelActionContent, CancelFlowStepType } from "../../types/cancelFlow"
import { CoachingGroup } from "../../types/coachingGroups"
import { createJoonAPIClient } from "../../util/joon-api"

export const getCoachingGroups = async () => {
  const API = createJoonAPIClient()
  return API.get<{ results: CoachingGroup[] }>("/api/coaching-groups/", {
    params: { role: UserRole.COACH },
  }).then((response) => response.data.results)
}

export async function loadRecommendedCoaches() {
  const joonApiClient = createJoonAPIClient()
  try {
    const response = await joonApiClient.get<{ profiles: CoachProfile[] }>(
      "api/coaching-groups/recommended-profiles/"
    )
    return response.data.profiles
  } catch (error) {
    throw error
  }
}

export async function loadRecommendedCoachesSummary() {
  const joonApiClient = createJoonAPIClient()
  try {
    const response = await joonApiClient.get<{
      response_summary: string | null
    }>("api/coaching-groups/recommended-profiles/")
    return response.data.response_summary
  } catch (error) {
    throw error
  }
}

export const loadCoachSubscriptionPackages = async () => {
  const joonApiClient = createJoonAPIClient()
  try {
    const response = await joonApiClient.get<SubscriptionPackagesResponse>(
      "api/coaching-groups/subscription-packages/"
    )
    return response.data
  } catch (error) {
    throw error
  }
}

export const unpauseCoachSubscription = async () => {
  const API = createJoonAPIClient()
  return API.post("api/coaching-groups/unpause-subscription/")
}

export const cancelCoachSubscription = async ({
  flowStepType,
  pauseLength,
}: {
  flowStepType: CancelFlowStepType
  pauseLength?: number
}) => {
  const API = createJoonAPIClient()
  return API.post<CancelActionContent>("api/coaching-groups/cancel/", {
    flow_step_type: flowStepType,
    pause_length: pauseLength,
  }).then((res) => res.data)
}

export const getMeTabCard = async ({
  hasSeenRoutineFlag,
}: {
  hasSeenRoutineFlag: boolean
}) => {
  const API = createJoonAPIClient()
  return API.get<MeTabCard>(`api/coaching-groups/me-card/`, {
    params: { has_seen_routine_flag: hasSeenRoutineFlag },
  }).then((response) => response.data)
}
